import { render } from "./SelectionSwitch.vue?vue&type=template&id=35814196&scoped=true"
import script from "./SelectionSwitch.vue?vue&type=script&lang=js"
export * from "./SelectionSwitch.vue?vue&type=script&lang=js"

import "./SelectionSwitch.vue?vue&type=style&index=0&id=35814196&scoped=true&lang=css"

import exportComponent from "/Users/yalemarc/Documents/yaleapps/simplify-photo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35814196"]])

export default __exports__